var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Paper } from '@mui/material';
import { FlexCol, FlexRow } from '@xyo-network/sdk-xyo-react-js';
import { FaAngleDown } from 'react-icons/fa';
import StatCardHeader from './StatCardHeader';
import StatCardSummary from './StatCardSummary';
const StatCard = (_a) => {
    var { onRefreshClick, onExpandClick, onActionClick, actionTo, action, title, description, subtitle, whole, image, value } = _a, props = __rest(_a, ["onRefreshClick", "onExpandClick", "onActionClick", "actionTo", "action", "title", "description", "subtitle", "whole", "image", "value"]);
    return (_jsx(FlexCol, Object.assign({ busy: value === undefined, borderRadius: 2, overflow: "hidden", alignItems: "stretch" }, props, { children: _jsxs(Paper, { children: [_jsxs(FlexCol, Object.assign({ style: {
                        backgroundAttachment: 'cover',
                        backgroundImage: `url(${image})`,
                        backgroundPositionX: 'right',
                        backgroundPositionY: 'bottom',
                        backgroundRepeat: 'no-repeat',
                    }, alignItems: "stretch" }, { children: [_jsx(StatCardHeader, { title: title, subtitle: subtitle, onRefreshClick: onRefreshClick, onActionClick: onActionClick, actionTo: actionTo, action: action }, void 0), _jsx(StatCardSummary, { format: whole ? '0,0.a' : '0,0.0a', value: value, title: description }, void 0)] }), void 0), onExpandClick ? (_jsx(FlexRow, Object.assign({ borderTop: "1px solid gray", style: { opacity: 0.7 } }, { children: _jsx(IconButton, Object.assign({ size: "small", onClick: onExpandClick }, { children: _jsx(FaAngleDown, { size: 24 }, void 0) }), void 0) }), void 0)) : null] }, void 0) }), void 0));
};
export default StatCard;
//# sourceMappingURL=StatCard.js.map